<script setup>
import { StealiePhoneInput } from "@get-overalls/fe-stealie";

defineProps({
  questionId: {
    type: [String, Number],
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  initialValue: {
    type: String,
    required: false,
    default: "",
  },
  placeholder: {
    type: String,
    required: false,
  },
  optional: {
    type: Boolean,
    required: false,
    default: false,
  },
  type: {
    type: String,
    required: true,
    validator(value) {
      return [
        "TextInput",
        "MultilineTextInput",
        "PhoneNumberInput",
        "ManagedEmailInput",
      ].includes(value);
    },
  },
});

const inputModel = defineModel({ type: String });
</script>

<template>
  <div class="mt-2">
    <textarea
      v-if="type === 'MultilineTextInput'"
      v-bind="$attrs"
      :id="name"
      v-model="inputModel"
      :name="name"
      :aria-describedby="`question-label-${questionId}`"
      class="col-start-1 row-start-1 block min-h-17 w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline-2 -outline-offset-1 outline-brand-gray-100 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-focus-highlight-light sm:text-sm/6"
      :required="!optional"
    />
    <StealiePhoneInput
      v-else-if="type === 'PhoneNumberInput'"
      v-bind="$attrs"
      :id="name"
      v-model="inputModel"
      :name="name"
      label="Phone number"
      mask="(999) 999-9999"
      slot-char=" "
      placeholder="E.g., (212) 555-1234"
      :aria-describedby="`question-label-${questionId}`"
      :required="!optional"
      class="col-start-1 row-start-1 block w-full [label:has(+&)]:sr-only"
    />
    <input
      v-else
      v-bind="$attrs"
      :id="name"
      v-model="inputModel"
      :name="name"
      :aria-describedby="`question-label-${questionId}`"
      class="col-start-1 row-start-1 block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline-2 -outline-offset-1 outline-brand-gray-100 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-focus-highlight-light sm:text-sm/6"
      :type="type === 'ManagedEmailInput' ? 'email' : 'text'"
      :placeholder="placeholder"
      :required="!optional"
    />
  </div>
</template>
